import { render, staticRenderFns } from "./edit_quote.vue?vue&type=template&id=cd72d34e&scoped=true"
import script from "./edit_quote.vue?vue&type=script&lang=js"
export * from "./edit_quote.vue?vue&type=script&lang=js"
import style0 from "./edit_quote.vue?vue&type=style&index=0&id=cd72d34e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd72d34e",
  null
  
)

export default component.exports